"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var multiselect_styles_1 = require("./multiselect.styles");
var toggle_1 = require("../toggle/toggle");
var toggle_all_1 = require("../toggle/toggle-all");
var button_1 = require("../../button/button");
var filterLink_1 = require("../../dropdown/filterLink/filterLink");
var search_1 = require("../search/search");
var react_1 = require("react");
var useClickOutside_1 = require("../../../hooks/useClickOutside");
var analyticsService_1 = require("../../../analytics/analyticsService");
var multiSelectReducer_1 = require("./multiSelectReducer");
var optionHeight = 40;
exports.MultiSelectDropdown = function (props) {
    var firstRun = react_1.useRef(true);
    var selectNode = react_1.useRef(null);
    var cachedSelection = react_1.useRef(props.selected ? props.selected : getAllOptions());
    var initialState = __assign(__assign({}, multiSelectReducer_1.initialMultiSelectState), { selectedOptions: props.selected });
    var _a = react_1.useReducer(multiSelectReducer_1.multiselectReducer, initialState), state = _a[0], dispatch = _a[1];
    react_1.useEffect(function () {
        if (state.showOptions) {
            dispatch({
                type: "setCanApply",
                payload: !arraysAreSame(cachedSelection.current, state.enabledOptions),
            });
        }
    }, [state.enabledOptions, state.showOptions]);
    useClickOutside_1.useClickOutside(selectNode, function () {
        if (state.showOptions) {
            dispatch({ type: "abandonChanges", payload: cachedSelection.current });
        }
    });
    react_1.useEffect(function () {
        if (firstRun.current) {
            firstRun.current = false;
            cachedSelection.current = props.selected.length > 0 ? props.selected : getAllOptions();
            return;
        }
        dispatch({ type: "reset", payload: props.selected });
        cachedSelection.current = props.selected.length > 0 ? props.selected : getAllOptions();
        // The join on props.selected to address the issue discussed here. React doesn't like it the array it depends on changes size
        // https://inventingwithmonster.io/20190207-how-to-fix-final-argument-passed-to-useeffect-changed-size-between-renders/
    }, [props.options, props.selected.join(",")]);
    react_1.useEffect(function () {
        if (state.showSelected) {
            var enabledOptions = state.enabledOptions.map(function (id) {
                return props.options.find(function (option) { return option.id == id; });
            });
            var results = enabledOptions.filter(function (options) {
                return options.value.toLowerCase().includes(state.searchTerm.toLowerCase());
            });
            dispatch({
                type: "applySearch",
                payload: {
                    availableOptions: props.options,
                    searchResults: results,
                },
            });
        }
        else {
            var results = props.options.filter(function (options) {
                return options.value.toLowerCase().includes(state.searchTerm.toLowerCase());
            });
            dispatch({
                type: "applySearch",
                payload: {
                    availableOptions: props.options,
                    searchResults: results,
                },
            });
        }
    }, [state.searchTerm, state.enabledOptions, state.allSelected]);
    react_1.useEffect(function () {
        if (state.showOptions) {
            var optionsArray = getAllOptions();
            var defaultOptions = state.selectedOptions && state.selectedOptions.length > 0
                ? state.selectedOptions
                : optionsArray;
            var allSelected = state.allSelected || arraysAreSame(optionsArray, defaultOptions);
            dispatch({
                type: "setEnabledOptions",
                payload: { enabledOptions: defaultOptions, allSelected: allSelected },
            });
        }
    }, [state.showOptions]);
    function getAllOptions() {
        // @ts-ignore
        return props.options.map(function (option) { return option.id; });
    }
    function toggleOptions() {
        dispatch({ type: "setShowOptions", payload: !state.showOptions });
    }
    function toggleOption(filter) {
        var enabledOptions;
        if (state.enabledOptions.find(function (enabledFilter) { return enabledFilter == filter; })) {
            enabledOptions = state.enabledOptions.filter(function (enabledFilter) { return enabledFilter != filter; });
        }
        else {
            enabledOptions = __spreadArrays(state.enabledOptions, [filter]);
        }
        dispatch({
            type: "setEnabledOptions",
            payload: {
                enabledOptions: enabledOptions,
                allSelected: enabledOptions.length === props.options.length,
            },
        });
    }
    function clearSelection() {
        dispatch({ type: "clearSelection" });
        analyticsService_1.AnalyticsService.recordEvent("select-none-" + props.id + "-multiselect");
    }
    function selectAll() {
        var enabledOptions = getAllOptions();
        dispatch({
            type: "setEnabledOptions",
            payload: {
                enabledOptions: enabledOptions,
                allSelected: true,
            },
        });
        analyticsService_1.AnalyticsService.recordEvent("select-all-" + props.id + "-multiselect");
    }
    function handleChange(e) {
        dispatch({ type: "setSearchTerm", payload: e.target.value });
    }
    function clearSearch() {
        dispatch({ type: "setSearchTerm", payload: "" });
    }
    function setShowAll() {
        var availableOptions = props.options;
        dispatch({
            type: "setShowAll",
            payload: availableOptions,
        });
    }
    function setShowSelected() {
        var enabledOptions = state.enabledOptions.map(function (id) {
            return props.options.find(function (option) { return option.id == id; });
        });
        dispatch({
            type: "setShowSelected",
            payload: enabledOptions,
        });
    }
    function closeDropdown() {
        dispatch({ type: "closeDropdown" });
        analyticsService_1.AnalyticsService.recordEvent("close-" + props.id + "-multiselect");
    }
    function applySelectionOptions() {
        var currentSelections = __spreadArrays(state.enabledOptions);
        dispatch({ type: "applySelection", payload: currentSelections });
        if (state.canApply) {
            analyticsService_1.AnalyticsService.recordEvent("apply-" + props.id + "-multiselect");
        }
        else {
            analyticsService_1.AnalyticsService.recordEvent("close-" + props.id + "-multiselect");
        }
        if (currentSelections.length !== 0) {
            cachedSelection.current = currentSelections;
        }
        var selectedOptions = currentSelections.map(function (selection) {
            return props.options.find(function (option) { return option.id == selection; });
        });
        props.updateSelection(selectedOptions);
    }
    function checkStatus() {
        switch (state.allSelected) {
            case true:
                return "checked";
            case false:
                if (state.enabledOptions.length > 0) {
                    return "partial";
                }
                else {
                    return "unchecked";
                }
        }
    }
    var optionsClass = props.showOnLeft ? multiselect_styles_1.optionsLeft : multiselect_styles_1.options;
    var top = optionHeight;
    return (React.createElement("div", { className: multiselect_styles_1.multiSelectContainer, ref: selectNode },
        React.createElement("div", { onClick: toggleOptions, className: multiselect_styles_1.filterContainer, id: props.id + "-list", "data-qa-type": "reportFilter" }, props.children ? (props.children) : (React.createElement(filterLink_1.FilterLink, { id: props.id, filterText: props.displayName, defaultValue: props.defaultValue, filterCount: cachedSelection.current.length, totalFilters: props.options.length, isShowingOptions: state.showOptions, isMulti: true, borderless: props.borderless }))),
        state.showOptions && (React.createElement("div", { className: optionsClass, style: { top: top }, id: props.id + "-options", ref: selectNode },
            React.createElement("div", { id: "users-search-container" },
                props.searchable ? (React.createElement(search_1.Search, { id: props.id + "-search", placeholder: "Search " + (props.searchField ? props.searchField : ""), handleChange: handleChange, clearSearch: clearSearch, searchTerm: state.searchTerm, disabled: props.options.length < 1 })) : null,
                state.showSelected && props.searchable ? (React.createElement("div", { className: multiselect_styles_1.showSelections, id: props.id + "-show-selected-toggle", "data-qa-display": "Show selected" },
                    React.createElement(button_1.Button, { className: multiselect_styles_1.showLink, id: "showAllLink", text: true, disabled: props.options.length < 1, onClick: setShowAll }, "Show all"),
                    React.createElement("span", { className: multiselect_styles_1.showCount },
                        state.enabledOptions.length,
                        " of ",
                        props.options.length))) : (React.createElement("div", { className: multiselect_styles_1.showSelections, id: props.id + "-show-selected-toggle", "data-qa-display": "Show all" },
                    React.createElement(button_1.Button, { className: multiselect_styles_1.showLink, id: "showSelected", text: true, disabled: props.options.length < 1, onClick: setShowSelected }, "Show selected"),
                    React.createElement("span", { id: props.id + "-selected-options-count", className: multiselect_styles_1.showCount },
                        state.enabledOptions.length,
                        " of ",
                        props.options.length)))),
            React.createElement("div", { className: multiselect_styles_1.optionsContainer },
                React.createElement("ul", { className: multiselect_styles_1.multiselectList },
                    React.createElement("li", { className: multiselect_styles_1.optionsDiv, id: "toggle-options", "data-qa": "dropdown-option-toggle-all" },
                        React.createElement(toggle_all_1.ToggleAll, { id: props.id + "-global-toggle", text: props.displayName, toggleOption: state.allSelected
                                ? function () { return clearSelection(); }
                                : function () { return selectAll(); }, checkstatus: checkStatus() })),
                    state.searchResults.map(function (option) { return (React.createElement("li", { key: option.id, className: multiselect_styles_1.optionsDiv, id: option.id + "-option", "data-qa": "dropdown-option" },
                        React.createElement(toggle_1.Toggle, { id: option.id, text: option.value, toggleOption: toggleOption, checked: state.enabledOptions.find(function (id) { return id == option.id; })
                                ? true
                                : false }))); }))),
            React.createElement("div", { className: multiselect_styles_1.optionsButtons },
                React.createElement(button_1.Button, { id: state.canApply ? "apply" : "close", className: multiselect_styles_1.actionButton, onClick: state.canApply ? applySelectionOptions : closeDropdown }, state.canApply ? "Apply" : "Close"))))));
};
exports.MultiSelectDropdown.defaultProps = {
    selected: [],
};
function arraysAreSame(array1, array2) {
    if (!array1 || !array2) {
        return false;
    }
    if (array1.length !== array2.length) {
        return false;
    }
    var array1Sorted = __spreadArrays(array1).sort();
    var array2Sorted = __spreadArrays(array2).sort();
    for (var i = 0; i < array1Sorted.length; i++) {
        if (array1Sorted[i] !== array2Sorted[i]) {
            return false;
        }
    }
    return true;
}
